import Incident from 'pages/Terrain/Events/Incident'
import ControleSpecifique from 'pages/Terrain/Events/ControleSpecifique'
import {
  EVENTS_MAIN_TYPE_CARE_RESCUE,
  EVENTS_MAIN_TYPE_DELIVERY,
  EVENTS_MAIN_TYPE_INCIDENT,
  EVENTS_MAIN_TYPE_LOGISTIC,
  EVENTS_MAIN_TYPE_OBSERVATION,
  EVENTS_MAIN_TYPE_PRESENCE,
  EVENTS_MAIN_TYPE_SPECIFIC_CONTROL
} from '@/consts/events'

export const ROUTE_NAME_TERRAIN_EVENTS_INCIDENT = 'terrainEventsIncident'
export default [
  {
    path: 'incident/:reference?',
    name: ROUTE_NAME_TERRAIN_EVENTS_INCIDENT,
    component: Incident,
    props: true,
    meta: {
      label: 'Incident',
      typeKey: EVENTS_MAIN_TYPE_INCIDENT
    }
  },
  {
    path: 'presence',
    name: 'terrainEventsPresence',
    redirect: {
      name: ROUTE_NAME_TERRAIN_EVENTS_INCIDENT,
      query: {
        typeKey: EVENTS_MAIN_TYPE_PRESENCE
      }
    },
    meta: {
      label: 'Présence',
      typeKey: EVENTS_MAIN_TYPE_PRESENCE
    }
  },
  {
    path: 'controleSpecifique',
    name: 'terrainEventsControleSpecifique',
    component: ControleSpecifique,
    redirect: {
      name: ROUTE_NAME_TERRAIN_EVENTS_INCIDENT,
      query: {
        typeKey: EVENTS_MAIN_TYPE_SPECIFIC_CONTROL
      }
    },
    meta: {
      label: 'Contrôle spécifique',
      typeKey: EVENTS_MAIN_TYPE_SPECIFIC_CONTROL
    }
  },
  {
    path: 'logistique',
    name: 'terrainEventsLogistique',
    redirect: {
      name: ROUTE_NAME_TERRAIN_EVENTS_INCIDENT,
      query: {
        typeKey: EVENTS_MAIN_TYPE_LOGISTIC
      }
    },
    meta: {
      label: 'Logistique',
      typeKey: EVENTS_MAIN_TYPE_LOGISTIC
    }
  },
  {
    path: 'care-rescue',
    name: 'terrainEventsCareRescue',
    redirect: {
      name: ROUTE_NAME_TERRAIN_EVENTS_INCIDENT,
      query: {
        typeKey: EVENTS_MAIN_TYPE_CARE_RESCUE
      }
    },
    meta: {
      label: 'Soins et secours',
      typeKey: EVENTS_MAIN_TYPE_CARE_RESCUE
    }
  },
  {
    path: 'delivery',
    name: 'terrainEventsDelivery',
    redirect: {
      name: ROUTE_NAME_TERRAIN_EVENTS_INCIDENT,
      query: {
        typeKey: EVENTS_MAIN_TYPE_DELIVERY
      }
    },
    meta: {
      label: 'Livraison',
      typeKey: EVENTS_MAIN_TYPE_DELIVERY
    }
  },
  {
    path: 'observations',
    name: 'terrainEventsObservations',
    redirect: {
      name: ROUTE_NAME_TERRAIN_EVENTS_INCIDENT,
      query: {
        typeKey: EVENTS_MAIN_TYPE_OBSERVATION
      }
    },
    meta: {
      label: 'Observations',
      typeKey: EVENTS_MAIN_TYPE_OBSERVATION
    }
  }
]
